/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getExchangeContract} from '../api'

 export const useQueryGetExchangeContract = createReactQueryHook('getExchangeContract', getExchangeContract)
